module.exports = __webpack_public_path__ + "img/identityC.3a0f6dde.png";